import React, { useState, useEffect } from 'react';

const ResponseExample = ({ responses, isDarkMode = false }) => {
  const availableTabs = Object.keys(responses);
  const [activeTab, setActiveTab] = useState(availableTabs[0] || 'success');
  
  // Reset to first available tab when responses change
  useEffect(() => {
    if (availableTabs.length > 0 && !availableTabs.includes(activeTab)) {
      setActiveTab(availableTabs[0]);
    }
  }, [responses, availableTabs, activeTab]);
  
  const getTabLabel = (tab) => {
    switch(tab) {
      case 'success':
        return 'Success';
      case 'error':
        return 'Error';
      case 'webhook_success':
        return 'Webhook Success';
      case 'webhook_error':
        return 'Webhook Error';
      default:
        return tab.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    }
  };

  const getTabIcon = (tab) => {
    if (tab === 'success' || tab === 'webhook_success') {
      return (
        <svg className="w-4 h-4 mr-1 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      );
    } else if (tab === 'webhook_success') {
      return (
        <svg className="w-4 h-4 mr-1 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
        </svg>
      );
    } else {
      return (
        <svg className="w-4 h-4 mr-1 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      );
    }
  };
  
  return (
    <div className="mb-8">
      <h2 className={`text-lg font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Response Examples</h2>
      
      {availableTabs.length > 1 && (
        <div className={`flex space-x-1 p-1 rounded-lg mb-4 inline-flex ${isDarkMode ? 'bg-slate-800 border border-slate-700' : 'bg-gray-100'}`}>
          {availableTabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
                activeTab === tab
                  ? isDarkMode
                    ? 'bg-slate-700 text-slate-100 shadow-sm'
                    : 'bg-white text-gray-900 shadow-sm'
                  : isDarkMode
                    ? 'text-slate-400 hover:text-slate-200'
                    : 'text-gray-600 hover:text-gray-900'
              }`}
            >
              <span className="flex items-center">
                {getTabIcon(tab)}
                {getTabLabel(tab)}
              </span>
            </button>
          ))}
        </div>
      )}
      
      <div className={`rounded-lg p-4 overflow-x-auto ${
        isDarkMode 
          ? 'bg-slate-900 border border-slate-700' 
          : 'bg-gray-900'
      }`}>
        <pre className={`text-sm ${
          isDarkMode 
            ? 'text-slate-200' 
            : 'text-gray-300'
        }`}>
          <code>{JSON.stringify(responses[activeTab], null, 2)}</code>
        </pre>
      </div>
    </div>
  );
};

export default ResponseExample;
